const animateContentRow = (selector, options) => {
    const elements = gsap.utils.toArray(selector);

    if (!elements.length) {
        return;
    }

    // Groepeer targets per contentrow zodat elke rij pas triggert wanneer hij zelf in beeld komt.
    const groups = new Map();

    elements.forEach((element) => {
        const trigger = element.closest(".contentrow") || element;
        if (!groups.has(trigger)) {
            groups.set(trigger, []);
        }

        groups.get(trigger).push(element);
    });

    groups.forEach((targets, trigger) => {
        gsap.to(targets, {
            scrollTrigger: {
                trigger,
                start: "-=300 center",
            },
            y: 0,
            delay: options?.delay || 0,
            opacity: 1,
            ease: "power1.inOut",
            duration: 0.3,
            stagger: options?.stagger || 0,
        });
    });
};

animateContentRow(".contentrow_1", { delay: 0 });
animateContentRow(".contentrow_2", { delay: 0 });
animateContentRow(".contentrow_3", { delay: 0 });
animateContentRow(".contentrow_4", { delay: 0 });
animateContentRow(".contentrow_5 .content__image", { delay: 0.15 });
animateContentRow(".contentrow_5 .contentrow__paragraph", { delay: 0.15 });
animateContentRow(".contentrow_6 .contentrow__paragraph", { delay: 0.15 });
animateContentRow(".contentrow_6 .content__image", { delay: 0.15 });
animateContentRow(".contentrow_7", { delay: 0 });
animateContentRow(".contentrow_8", { delay: 0 });
animateContentRow(".contentrow_9 img", { stagger: 0.15, delay: 0 });
animateContentRow(".contentrow_10 img", { stagger: 0.15, delay: 0 });
animateContentRow(".contentrow_10 a", { stagger: 0.15, delay: 0 });
animateContentRow(".contentrow_11", { delay: 0 });
animateContentRow(".contentrow_12", { delay: 0 });
animateContentRow(".contentrow_13", { delay: 0 });
animateContentRow(".contentrow_14", { delay: 0 });
animateContentRow(".contentrow_15", { delay: 0 });
animateContentRow(".contentrow_16", { delay: 0 });
animateContentRow(".contentrow_17", { delay: 0 });
animateContentRow(".contentrow_18", { delay: 0 });
animateContentRow(".contentrow_19", { delay: 0 });
animateContentRow(".contentrow_20", { delay: 0 });
animateContentRow(".contentrow_21", { delay: 0 });
animateContentRow(".contentrow_22", { delay: 0 });
animateContentRow(".contentrow__projects", { delay: 0 });
animateContentRow(".usp__section--contentrow", { delay: 0 });
animateContentRow(".blocks__section", { delay: 0 });

// Functie om de schaal van de afbeelding te vergroten bij mouseover
const scaleImageOnHover = (selector) => {
    const images = document.querySelectorAll(selector);

    if (!images.length) return;

    images.forEach((image) => {
        image.addEventListener('mouseover', () => {
            gsap.to(image, { scale: 1.05, duration: 1 });
        });

        // Terug naar de normale schaal bij mouseout
        image.addEventListener('mouseout', () => {
            gsap.to(image, { scale: 1, duration: 1 });
        });
    });
};

// Roep de functie aan voor de gewenste afbeeldingen
scaleImageOnHover('.contentrow_3 img');
scaleImageOnHover('.contentrow_5 img');
scaleImageOnHover('.contentrow_6 img');
scaleImageOnHover('.contentrow_9 img');
scaleImageOnHover('.contentrow_10 img');
scaleImageOnHover('.contentrow_11 video');

// Wacht tot contentrow_18 verschijnt voordat de Swiper wordt geïnitialiseerd
const contentRow18 = document.querySelector('.contentrow_18');

if (contentRow18 && typeof ScrollTrigger !== 'undefined') {
    ScrollTrigger.create({
        trigger: contentRow18,
        start: "top center",
        onEnter: () => {
            // Check of Swiper beschikbaar is en het element bestaat
            const swiperElement = document.querySelector('.projectswiper');
            if (!swiperElement || typeof Swiper === 'undefined') {
                return;
            }

            const projectSwiper = new Swiper(swiperElement, {
                direction: 'horizontal',
                spaceBetween: 50,
                autoHeight: true,
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },
                speed: 1000,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                slidesPerView: 1,
                on: {
                    init: function () {
                        // Start de observer om autoplay te beheren
                        const observer = new IntersectionObserver((entries) => {
                            entries.forEach((entry) => {
                                if (entry.isIntersecting) {
                                    this.autoplay.start(); // Start autoplay als zichtbaar
                                } else {
                                    this.autoplay.stop(); // Stop autoplay als niet zichtbaar
                                }
                            });
                        });

                        // Voeg de Swiper-container toe aan de observer
                        observer.observe(this.el);
                    },
                },
            });
        },
        once: true, // Zorg ervoor dat de Swiper slechts één keer wordt geïnitialiseerd
    });
}
